// extracted by mini-css-extract-plugin
module.exports = {"container":"Recetas_container__32yIu","titulo":"Recetas_titulo__EibX3","subtitulos":"Recetas_subtitulos__33PZG","buttons":"Recetas_buttons__33Z6u"};